import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExamResultFileCategory } from '../../models/examResultFileCategory';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExamResultFileCategoryService {

  constructor(private http: HttpClient) { }

  list(): Observable<Array<ExamResultFileCategory>> {
    return this.http.get<Array<ExamResultFileCategory>>(`${environment.baseApiUrl}/exam_result_file_categories/`)
      .pipe(map((res: any) => res.map((d: any) => new ExamResultFileCategory(d))));
  }
}
